import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { environment } from "src/environments/environment";

@Pipe({
  name: "languageTranslate",
  pure: false,
})
export class LanguageTranslatePipe implements PipeTransform {
  name: any;
  language: any;
  lang: any;
  constructor(public translate: TranslateService) {}
  transform(value: any, arg2?: any): any {
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.language = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
      this.lang = this.language;
      this.translate.use(this.lang);
      if (value) {
        if (this.lang == "es" && value.language) {
          for (let i = 0; i < value.language.length; i++) {
            if (value.language[i].lang == "es") {
              this.name = value.language[i].name;
            } else {
              this.name = value.language[i].name;
            }
          }
        } else {
          this.name = value.name;
        }

        return this.name;
      }
    } else {
      this.name = value.name;
      return this.name;
    }
  }
}
